<div class="mat-overlay-spinner" fxLayout="row" fxLayoutAlign="center center">
    <mat-spinner diameter="50"></mat-spinner>
</div>   